const colors = {
  darkGrey: "#191919",
  // mainColor: "#FFDB00",
  mainColor: "#ffff00",

  white: "#ffffff",
}

export default colors
